export const SHOW_MESSAGE = 'message/SHOW_MESSAGE'